import { INDUSTRY_UNDEFINED_ID } from 'src/data/industry';
import { getContentTypeTaxonomyName } from 'src/data/contentType';

export const getTaxonomyMapper = (contentType) => {
  const label = getContentTypeTaxonomyName(contentType);
  const taxonomyMapper = (taxonomy) =>
    taxonomy.id === INDUSTRY_UNDEFINED_ID
      ? { ...taxonomy, name: `${taxonomy.name} ${label}` }
      : taxonomy;

  return taxonomyMapper;
};
